(function () {
  "use strict";

  document.addEventListener("click", function (event) {
    var open = event.target.closest("[data-menu-open]");
    var close = event.target.closest("[data-menu-close]");
    var panel = document.getElementById("MobileMenu");

    if (!panel) return;

    if (open) {
      panel.classList.add("is-open");
      document.body.style.overflow = "hidden";
      panel.setAttribute("aria-hidden", "false");
    }

    if (close || event.target === panel) {
      panel.classList.remove("is-open");
      document.body.style.overflow = "";
      panel.setAttribute("aria-hidden", "true");
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    var panel = document.getElementById("MobileMenu");
    if (!panel || !panel.classList.contains("is-open")) return;

    panel.classList.remove("is-open");
    panel.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  });

  document.addEventListener("click", function (event) {
    if (!event.target.closest("[data-search-toggle]")) return;

    var search = document.getElementById("HeaderSearch");
    if (!search) return;

    search.classList.toggle("is-open");
    var input = search.querySelector('input[type="search"]');
    if (input && search.classList.contains("is-open")) input.focus();
  });

  function prepareHomepageHeader() {
    if (!document.body.classList.contains("template-index")) return;

    var homeHeader = document.querySelector(
      "#shopify-section-amani-full header.site"
    );
    if (!homeHeader || homeHeader.querySelector(".amani-home-left")) return;

    var row = homeHeader.querySelector(".hd");
    var burger = homeHeader.querySelector(".burger");
    var icons = homeHeader.querySelector(".icons");
    var wishlist = icons && icons.querySelector('a[aria-label="Wishlist"]');
    if (!row || !burger || !icons || !wishlist) return;

    homeHeader.setAttribute("data-header", "");
    wishlist.href = "/pages/wishlist";
    wishlist.classList.add("desktop-wishlist");

    if (!wishlist.querySelector("[data-wishlist-count]")) {
      var desktopCount = document.createElement("span");
      desktopCount.className = "amani-wishlist-count";
      desktopCount.setAttribute("data-wishlist-count", "");
      wishlist.appendChild(desktopCount);
    }

    var left = document.createElement("div");
    left.className = "amani-home-left";
    row.insertBefore(left, burger);
    left.appendChild(burger);

    var mobileWishlist = wishlist.cloneNode(true);
    mobileWishlist.classList.remove("desktop-wishlist");
    mobileWishlist.classList.add("mobile-wishlist");
    left.appendChild(mobileWishlist);

    var search = icons.querySelector('a[aria-label="Search"]');
    if (search) search.classList.add("header-search");
  }

  prepareHomepageHeader();

  var header = document.querySelector("[data-header]");
  if (header) {
    var updateHeader = function () {
      header.classList.toggle("is-stuck", window.scrollY > 12);
    };

    window.addEventListener("scroll", updateHeader, { passive: true });
    updateHeader();
  }

  var LEGACY_KEY = "amani_wishlist";
  var V2_PREFIX = "amani_wishlist_v2:";
  var customerId = document.body.getAttribute("data-customer-id") || "guest";
  var activeKey = V2_PREFIX + customerId;
  var guestKey = V2_PREFIX + "guest";
  var addLabel =
    document.body.getAttribute("data-wishlist-add") || "Add to wishlist";
  var savedLabel =
    document.body.getAttribute("data-wishlist-saved") || "Saved to wishlist";

  function parse(value) {
    try {
      var parsed = JSON.parse(value || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function readKey(key) {
    try {
      return parse(localStorage.getItem(key));
    } catch (error) {
      return [];
    }
  }

  function normalize(item) {
    if (item === null || item === undefined) return null;
    if (typeof item === "string" || typeof item === "number") {
      return { id: String(item) };
    }

    return {
      id: item.id ? String(item.id) : "",
      handle: item.handle || "",
      url: item.url || "",
      title: item.title || "",
      image: item.image || "",
      price: item.price || "",
      available: item.available !== false,
    };
  }

  function sameProduct(left, right) {
    if (!left || !right) return false;
    if (left.id && right.id && String(left.id) === String(right.id)) return true;
    return Boolean(
      left.handle && right.handle && left.handle === right.handle
    );
  }

  function mergeLists() {
    var merged = [];

    Array.prototype.slice.call(arguments).forEach(function (source) {
      source.map(normalize).filter(Boolean).forEach(function (item) {
        var index = merged.findIndex(function (saved) {
          return sameProduct(saved, item);
        });

        if (index === -1) {
          merged.push(item);
        } else {
          merged[index] = Object.assign({}, merged[index], item);
        }
      });
    });

    return merged;
  }

  var list = mergeLists(
    readKey(activeKey),
    customerId !== "guest" ? readKey(guestKey) : [],
    readKey(LEGACY_KEY)
  );

  function persist() {
    try {
      localStorage.setItem(activeKey, JSON.stringify(list));
      localStorage.setItem(
        LEGACY_KEY,
        JSON.stringify(
          list.map(function (item) {
            return item.id || item.handle;
          })
        )
      );

      if (customerId !== "guest") localStorage.removeItem(guestKey);
    } catch (error) {
      return;
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function handleFromUrl(url) {
    var match = String(url || "").match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }

  function cardFor(button) {
    return button.closest(".abx-card, .pcard, .amani-card, .awp__card");
  }

  function productFromButton(button) {
    var card = cardFor(button);
    var root = button.closest(".abx-pinfo") || card || document;
    var link =
      (card &&
        card.querySelector(
          'a[href*="/products/"].abx-card__media, a[href*="/products/"].pcard__media, a[href*="/products/"]'
        )) ||
      document.querySelector('link[rel="canonical"]');
    var url =
      button.getAttribute("data-wishlist-url") ||
      (link && (link.getAttribute("href") || link.getAttribute("content"))) ||
      window.location.pathname;
    var idInput = document.querySelector(
      '.template-product input[name="product-id"]'
    );
    var titleNode =
      root.querySelector(".abx-card__title, .pname, .amani-name, h1") ||
      document.querySelector("h1");
    var priceNode =
      root.querySelector(".abx-card__price, .price, .amani-price, .abx-pprice") ||
      document.querySelector(".abx-pprice");
    var image = root.querySelector("img");
    var soldButton =
      root.querySelector(".abx-card__quick button[disabled]") ||
      document.querySelector(".abx-buyrow .abx-btn[disabled]");

    return normalize({
      id:
        button.getAttribute("data-wishlist-id") ||
        button.getAttribute("data-abx-wish") ||
        button.getAttribute("data-amani-wish") ||
        (idInput && idInput.value) ||
        handleFromUrl(url),
      handle:
        button.getAttribute("data-wishlist-handle") || handleFromUrl(url),
      url: url,
      title:
        button.getAttribute("data-wishlist-title") ||
        (titleNode && titleNode.textContent.trim()) ||
        document.title,
      image:
        button.getAttribute("data-wishlist-image") ||
        (image && (image.currentSrc || image.src)) ||
        "",
      price:
        button.getAttribute("data-wishlist-price") ||
        (priceNode && priceNode.textContent.trim()) ||
        "",
      available: !soldButton,
    });
  }

  function decorateButton(button) {
    button.setAttribute("data-wishlist-button", "");
    var product = productFromButton(button);
    var savedIndex = list.findIndex(function (item) {
      return sameProduct(item, product);
    });
    var saved = savedIndex !== -1;

    if (saved) {
      list[savedIndex] = Object.assign({}, list[savedIndex], product);
    }

    button.classList.toggle("is-saved", saved);
    button.classList.toggle("on", saved);
    button.setAttribute("aria-pressed", saved ? "true" : "false");
    button.setAttribute("aria-label", saved ? savedLabel : addLabel);

    var text = button.querySelector("[data-wishlist-label]");
    if (text) text.textContent = saved ? savedLabel : addLabel;
  }

  function updateButtons() {
    document
      .querySelectorAll(
        "[data-wishlist-button], [data-abx-wish], [data-amani-wish], button.wish"
      )
      .forEach(decorateButton);
  }

  function updateCount() {
    document.querySelectorAll("[data-wishlist-count]").forEach(function (node) {
      node.textContent = list.length ? String(list.length) : "";
      node.setAttribute("data-count", String(list.length));
    });
  }

  function injectProductButton() {
    if (!document.body.classList.contains("template-product")) return;
    if (document.querySelector(".abx-pinfo [data-wishlist-button]")) return;

    var price = document.querySelector(".abx-pinfo .abx-pprice");
    if (!price) return;

    var button = document.createElement("button");
    button.type = "button";
    button.className = "amani-wishlist-action";
    button.setAttribute("data-wishlist-button", "");
    button.setAttribute("aria-label", addLabel);
    button.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.2C.6 9 1.6 5.6 4.7 4.8 7 4.2 9.2 5.4 12 8c2.8-2.6 5-3.8 7.3-3.2 3.1.8 4.1 4.2 2.7 7C19.5 16.4 12 21 12 21z"/></svg><span data-wishlist-label></span>';
    price.insertAdjacentElement("afterend", button);
  }

  function renderWishlistPage() {
    var grid = document.querySelector("[data-wishlist-grid]");
    var empty = document.querySelector("[data-wishlist-empty]");
    if (!grid || !empty) return;

    var renderable = list.filter(function (item) {
      return item.url && item.title;
    });

    if (!renderable.length) {
      grid.innerHTML = "";
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    var removeLabel =
      grid.getAttribute("data-remove-label") || "Remove";
    var soldOutLabel =
      grid.getAttribute("data-sold-out-label") || "Sold out";

    grid.innerHTML = renderable
      .map(function (item) {
        var key = escapeHtml(item.id || item.handle);
        var image = item.image
          ? '<img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.title) +
            '" loading="lazy">'
          : "";
        var badge =
          item.available === false
            ? '<span class="awp__badge">' +
              escapeHtml(soldOutLabel) +
              "</span>"
            : "";

        return (
          '<article class="awp__card">' +
          '<a class="awp__media" href="' +
          escapeHtml(item.url) +
          '">' +
          badge +
          image +
          "</a>" +
          '<div class="awp__info">' +
          '<a class="awp__title" href="' +
          escapeHtml(item.url) +
          '">' +
          escapeHtml(item.title) +
          "</a>" +
          '<div class="awp__price">' +
          escapeHtml(item.price) +
          "</div>" +
          '<button type="button" class="awp__remove" data-wishlist-remove="' +
          key +
          '">' +
          escapeHtml(removeLabel) +
          "</button>" +
          "</div>" +
          "</article>"
        );
      })
      .join("");

    grid.hidden = false;
    empty.hidden = true;
  }

  function notify() {
    updateButtons();
    updateCount();
    renderWishlistPage();
    document.dispatchEvent(
      new CustomEvent("amani:wishlist", { detail: { count: list.length } })
    );
  }

  function hydrateLegacyItems() {
    if (!document.querySelector("[data-wishlist-page]")) return;

    var needsData = list.some(function (item) {
      return item.id && (!item.url || !item.title);
    });
    if (!needsData) return;

    fetch("/products.json?limit=250", {
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Wishlist products unavailable");
        return response.json();
      })
      .then(function (data) {
        var products = Array.isArray(data.products) ? data.products : [];
        var currency =
          (window.Shopify &&
            window.Shopify.currency &&
            window.Shopify.currency.active) ||
          "GBP";
        var formatter = new Intl.NumberFormat(
          document.documentElement.lang || "en-GB",
          { style: "currency", currency: currency }
        );

        list = list
          .map(function (item) {
            if (item.url && item.title) return item;

            var product = products.find(function (candidate) {
              return String(candidate.id) === String(item.id);
            });
            if (!product) return null;

            var variants = Array.isArray(product.variants)
              ? product.variants
              : [];
            var prices = variants
              .map(function (variant) {
                return Number.parseFloat(variant.price);
              })
              .filter(Number.isFinite);
            var price = prices.length ? Math.min.apply(Math, prices) : 0;

            return normalize({
              id: product.id,
              handle: product.handle,
              url: "/products/" + product.handle,
              title: product.title,
              image:
                product.images && product.images[0]
                  ? product.images[0].src
                  : "",
              price: formatter.format(price),
              available: variants.some(function (variant) {
                return variant.available;
              }),
            });
          })
          .filter(Boolean);

        persist();
        notify();
      })
      .catch(function () {
        return;
      });
  }

  document.addEventListener(
    "click",
    function (event) {
      var remove = event.target.closest("[data-wishlist-remove]");
      if (remove) {
        event.preventDefault();
        var key = remove.getAttribute("data-wishlist-remove");
        list = list.filter(function (item) {
          return String(item.id || item.handle) !== key;
        });
        persist();
        notify();
        return;
      }

      var button = event.target.closest(
        "[data-wishlist-button], [data-abx-wish], [data-amani-wish], button.wish"
      );
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var product = productFromButton(button);
      var index = list.findIndex(function (item) {
        return sameProduct(item, product);
      });

      if (index === -1) {
        list.unshift(product);
      } else {
        list.splice(index, 1);
      }

      persist();
      notify();
    },
    true
  );

  injectProductButton();
  notify();
  persist();
  hydrateLegacyItems();

  window.AmaniWishlist = {
    items: function () {
      return list.slice();
    },
    refresh: function () {
      updateButtons();
      updateCount();
    },
  };
})();
